import { render } from "./toggleSwitch.vue?vue&type=template&id=480825d1"
import script from "./toggleSwitch.vue?vue&type=script&lang=js"
export * from "./toggleSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__